/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackervalueform', {
      restrict: 'E',
      bindings: {
        trackervalue: '<',
        trackerid: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vctracker/trackervalueform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.formatdate = formatdate;
          vm.cleardate = cleardate;

          vm.$onInit = function () {
            vm.lasttrackervalue = angular.copy(vm.trackervalue);
          };
          
          function save() {
            $log.debug('trackervalue form save');
            if (!angular.equals(vm.trackervalue, vm.lasttrackervalue)) {
              $log.debug('trackervalue form now saving');
              vm.lasttrackervalue = angular.copy(vm.trackervalue);
              vm.parentsave({trackervalue: vm.trackervalue, trackerid: vm.trackerid});
            }
          }


          // trackerid might be propagating late
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.trackerid) &&
                angular.isDefined(changes.trackerid.currentValue &&
                changes.trackerid.currentValue.length > 0)) {
              vm.trackerid = changes.trackerid.currentValue;
            }
          };


          function cancel() {
            vm.trackervalue = angular.copy(vm.lasttrackervalue);
            vm.oncancel();
          }


          function formatdate(fdate) {
            // moment.locale('de-at');
            let returnval;
            let date = moment(fdate, ['D.M.YYYY', 'DD.MM.YYYY', 'D/M/YYYY', 'DDMMYYYY']);
            let plausible = (date.isAfter(moment('1900-01-01', 'YYYY-MM-DD')) && date.isBefore(moment().add(1, 'days')));
            let valid = date.isValid();
            // $log.debug('debug: valid, plausible: ', valid, plausible);

            if (!plausible) {
              vm.dateerror = 'Unplausibles Datum';
              returnval = 'implausible';
            }

            if (!valid) {
              vm.dateerror = 'Ungültiges Datum';
              returnval = 'invalid';
            }

            if (valid && plausible) {
              vm.trackervalue.dateiso = date.toISOString();
              vm.trackervalue.datesortable = date.format('YYYY-MM-DD');
              vm.trackervalue.dateat = date.format('DD.MM.YYYY');
              vm.trackervalue.datejs = date.format();
              vm.trackervalue.datesv = date.format('DDMMYY');
              delete vm.dateerror;
              returnval = date.format('DD.MM.YYYY');
            }
            return returnval;
          }

          function cleardate() {
            delete vm.trackervalue.date;
            delete vm.trackervalue.dateiso;
            delete vm.trackervalue.datesortable;
            delete vm.trackervalue.datejs;
            delete vm.trackervalue.dateat;
            delete vm.trackervalue.datesv;
            delete vm.dateerror;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());